import {
  TaggregatedCheckIns,
  TEmployeeData,
  Tleaves,
  TTeamWiseEmployeeData,
} from '../types/analyticsTypes';

import { countWorkingDays } from '.';

export const getEmployeeData = (
  employee: TaggregatedCheckIns,
  individualCheckIns: TTeamWiseEmployeeData,
  totalWorkingDays: number,
  leavesMap: { [key: string]: number },
  todayOooMap: { [key: string]: boolean },
): TEmployeeData => {
  const existingData =
    individualCheckIns[employee.team_name]?.[employee.user_id] || {};
  const checkInData =
    employee.daily_sequence === 1
      ? { midDayCheckIns: employee.check_in_count }
      : { endDayCheckIns: employee.check_in_count };
  return {
    ...existingData,
    totalWorkingDays:
      existingData.totalWorkingDays ||
      totalWorkingDays - (leavesMap[employee.employee_id] || 0),
    name: existingData.name || `${employee.first_name} ${employee.last_name}`,
    midDayCheckIns: existingData.midDayCheckIns || 0,
    endDayCheckIns: existingData.endDayCheckIns || 0,
    isOOOToday: todayOooMap[employee.employee_id],
    ...checkInData,
  };
};

export const mapCheckIns = (
  aggregatedCheckIns: TaggregatedCheckIns[],
  leavesMap: { [key: string]: number },
  todayOooMap: { [key: string]: boolean },
  totalWorkingDays: number,
): TTeamWiseEmployeeData => {
  const checkInsMap: TTeamWiseEmployeeData = {};
  aggregatedCheckIns?.forEach((employee) => {
    if (employee.team_name === 'BC Experience') {
      return;
    }
    const employeeData = getEmployeeData(
      employee,
      checkInsMap,
      totalWorkingDays,
      leavesMap,
      todayOooMap,
    );
    checkInsMap[employee.team_name] = {
      ...(checkInsMap[employee.team_name] || {}),
      [employee.user_id]: employeeData,
    };
  });
  return checkInsMap;
};

export const mapLeaves = (
  leaves: Tleaves[],
  startDate: string,
  endDate: string,
): {
  leavesMap: { [key: string]: number };
  todayOooMap: { [key: string]: boolean };
} => {
  const leavesMap: { [key: string]: number } = {};
  const today = new Date().toISOString().split('T')[0];
  const todayOooMap: { [key: string]: boolean } = {};
  leaves?.forEach((leave) => {
    if (leave.status === 'approved' || leave.status === 'pending') {
      const normalizedStartDate = new Date(`${startDate}T00:00:00Z`);
      const normalizedLeaveStartDate = new Date(leave.start_date);
      const normalizedEndDate = new Date(`${endDate}T00:00:00Z`);
      const normalizedLeaveEndDate = new Date(leave.end_date);

      const currentStartDate =
        normalizedStartDate >= normalizedLeaveStartDate
          ? `${startDate}T00:00:00+00:00`
          : leave.start_date;
      const currentEndDate =
        normalizedEndDate <= normalizedLeaveEndDate
          ? `${endDate}T00:00:00+00:00`
          : leave.end_date;
      const workingDays = countWorkingDays(currentStartDate, currentEndDate);
      leavesMap[leave.employee_id] =
        (leavesMap[leave.employee_id] || 0) + workingDays;

      if (
        leave.start_date.substring(0, 10) <= today &&
        leave.end_date.substring(0, 10) >= today
      ) {
        todayOooMap[leave.employee_id] = true;
      }
    }
  });
  return { leavesMap, todayOooMap };
};
